import {Button, Icon} from '@ezcater/tapas';
import {faBuildings} from '@fortawesome/pro-regular-svg-icons';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import {twJoin} from 'tailwind-merge';

import {SelectableCorpAccount} from '@/components/global/layout/EventBar/useOrderAccounts';
import {getCorpDisplayName} from './utils';

type CorpAccountSelectionOptionProps = {
  corpAccount: SelectableCorpAccount;
  isSelected: boolean;
  onClick: () => void;
  className?: string;
};

const CorpAccountSelectionOption: React.FC<CorpAccountSelectionOptionProps> = ({
  corpAccount,
  isSelected,
  onClick = () => {},
  className,
}) => {
  const {t} = useTranslation('app-bar');

  return (
    <Button
      aria-selected={isSelected}
      className={twJoin(
        'flex items-start justify-start gap-3 text-left font-semibold aria-selected:bg-peppercorn-100',
        className,
      )}
      onClick={onClick}
      role="option"
      variant="secondary"
    >
      {corpAccount?.logoIconUrl ? (
        <Image
          src={corpAccount.logoIconUrl}
          alt={t('menus.corporateAccounts.accountPicker.logoIconAlt', {
            accountName: getCorpDisplayName(corpAccount),
          })}
          width={20}
          height={20}
          className="h-5 w-5 pt-0.5"
        />
      ) : (
        <Icon className="flex h-5 w-5 shrink-0 pt-0.5" icon={faBuildings} size="small" />
      )}
      {getCorpDisplayName(corpAccount)}
    </Button>
  );
};

export default CorpAccountSelectionOption;
